import gql from 'graphql-tag';

const getAccountCardPromoCodesQuery = gql`
  query getAccountCardPromoCodes {
    me {
      id
      affiliate_urls(types: WALDOGRAM_PROMO) {
        records {
          id
          url
        }
      }
      promo_codes(types: WALDOGRAM_PROMO) {
        records {
          id
          code
          type
        }
      }
    }
  }
`;

export default getAccountCardPromoCodesQuery;
